<template>
    <el-dialog width="620px" title="产品编辑" :before-close="handleClickCancel" class="ordinary_dialog" :close-on-press-escape="false"
               :close-on-click-modal="false" :visible.sync="combinationEditVisible" append-to-body>
        <div class="ordinary_edit_wrap" v-loading="loading">
            <el-form size="small" ref="generalForm"   v-loading="loading"  label-position="top" :model="productForm"  :rules="productFormRules">
                <div class="custom_title"><span>基本信息</span></div>
                <el-form-item label="产品名称" prop="goods_name">
                    <el-input v-model="productForm.goods_name"  placeholder="请输入名称"></el-input>
                </el-form-item>

                <el-form-item label="产品图片" prop="image">
                    <div class="image_outer_wrap">
                        <ul  class="upload_image_list">
                            <li v-for="(item,index) in productForm.image"
                                :key="index"
                                class="upload_image_item">
                                <i @click="productForm.image.splice(index,1)" class="el-icon-error"></i>
                                <el-image
                                        :preview-src-list="productForm.image.map(img=>img)"
                                        :src="item"
                                        fit="cover">
                                </el-image>

                            </li>
                            <li class="image_upload_wrap">
                                <input accept=".png, .jpg, .jpeg"
                                       class="upload_input"
                                       multiple
                                       type="file"
                                       @change="handleClickUploadImg($event,productForm.image)">
                                <i class="el-icon-plus"></i>
                            </li>
                        </ul>
                        <p class="image_hint">从本地上传图片，支持多张上传、多种图片格式。</p>
                    </div>
                </el-form-item>


                <el-form-item label="产品描述" prop="description">
                    <el-input v-model="productForm.description" type="textarea"  placeholder="请输入产品描述" ></el-input>
                </el-form-item>

                <el-form-item label="是否可销售" prop="is_sale">
                    <template v-slot:label>
                        <div class="flex_wrap">
                            <span>是否可销售</span>
                            <div class="label_position ml_16"><el-switch  v-model="productForm.is_sale" :active-value="1" :inactive-value="0"  active-color="#2990FF"></el-switch><span class="ml_8" v-text="productForm.is_sale == 1 ?'是' : '否'"></span></div>
                        </div>
                    </template>
                    <p class="hint">开关关闭，在下订单时该产品不允许销售</p>
                </el-form-item>


                <el-form-item label="是否可租借" prop="is_lease">
                    <template v-slot:label>
                        <div class="flex_wrap">
                            <span>是否可租借</span>
                            <div class="label_position ml_16"><el-switch  v-model="productForm.is_lease" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="ml_8" v-text="productForm.is_lease == 1 ?'是' : '否'"></span></div>
                        </div>
                    </template>
                    <p class="hint">开关关闭，在下订单时该产品不允许租借</p>
                </el-form-item>

                <div class="custom_title"><span>配置信息</span></div>
                <div class="combination_product">
                    <ul>
                        <draggable v-model="productForm.part" >
                            <li v-for="(item,index) in productForm.part" :key="index">
                            <div class="region_name_wrap">
                                <el-input v-model="item.part_name" size="small" placeholder="请输入部位名称" ></el-input>
                                <div class="custom_input_number">
                                    <el-input-number v-model="item.num"  size="small"   :min="1"  placeholder="" ></el-input-number>
                                </div>
                                <span class="handle_icon_wrap" @click="productForm.part.splice(index,1)"><i class="iconfont icon-shanchu1"></i></span>
                            </div>
                            <div class="default_number_repeat">
                                <div>默认展示：<el-switch  v-model="item.is_show" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="switch_text" v-text="item.is_show == 1 ?'是' : '否'"></span></div>
                                <div>数量可修改：<el-switch  v-model="item.num_edit" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="switch_text" v-text="item.num_edit == 1 ?'是' : '否'"></span></div>
                                <div>允许重复添加：<el-switch  v-model="item.is_add" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="switch_text" v-text="item.is_add == 1 ?'是' : '否'"></span></div>
                            </div>
                            <div class="product_item">
                                <div class="product_item_top">
                                    <div class="product_item_name">
                                        <span class="ellipsis">产品名称 <span v-if="item.type == 'basic' && item.goods_list.length>0">（{{item.goods_list[0].goods_name}}）</span></span>
                                        <el-button v-if="item.type == 'basic'" type="text" @click="handleClickChangeProduct(item,'switch')"><i class="iconfont icon-qiehuan"></i>切换产品</el-button>
                                        <el-button v-else type="text" @click="handleClickChangeProduct(item,'add')"><i class="iconfont icon-tianjia1"></i>添加产品</el-button>
                                    </div>
                                    <div class="product_item_handle">
                                        <span v-text="item.type == 'basic' ? '是否启用' : '操作'"></span>
                                    </div>
                                </div>
                                <div class="product_item_bottom" v-if="item.goods_list && item.goods_list.length>0">
                                    <div class="list" v-for="(list,index) in item.type != 'basic' ? item.goods_list : item.goods_list[0].skus" :key="index">
                                        <div class="product_item_name">
                                            {{list.goods_name}}
                                        </div>
                                        <div class="product_item_handle">
                                            <el-switch v-if="item.type == 'basic'" v-model="list.status" active-color="#2990FF"></el-switch><span class="switch_text" v-if="item.type == 'basic'" v-text="list.status ?'是' : '否'">是</span>
                                            <span v-if="item.type != 'basic'" class="handle_icon_wrap handle_icon_danger_wrap" @click="item.goods_list.splice(index,1)"><i class="iconfont icon-shanchu1"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        </draggable>
                    </ul>
                    <div class="combination_product_handle"  @click="handleClickAddRegion">
                        <span ><i class="el-icon-plus"></i>添加部位</span>
                    </div>
                </div>
            </el-form>

        </div>
        <div slot="footer">
            <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确定</el-button>
        </div>
        <RegionAdd :regionAddVisible.sync="regionAddVisible" v-if="regionAddVisible" :selectedData="selectedData"  @success="regionAddSuccess"/>

    </el-dialog>
</template>
<script>
import { GoodsBundleProductDetail ,GoodsBundleProductEdit} from '@/api'
import {uploadImg} from '@/utils/uploadOss'
import RegionAdd from "./region_add"
import draggable from 'vuedraggable'
export default {
    name: 'combination_edit', //组合产品
    components: {
        RegionAdd,
        draggable
    },
    props: {
        combinationEditVisible: {
            type: Boolean,
            default: false,
        },
        goodsId: {
            type: Number,
            default: 0,
        },
        goodsType: {
            type: String,
            default: '',
        },
        goodsInfo: {
            type: Object,
            default: ()=>{},
        },

    },
    data() {
        return {
            loading:false,
            BtnDisabled: false,
            productForm:{
                goods_name: "",
                image: [],
                description: "",
                is_sale: 1,
                is_lease: 1,
                part:[
                    {
                        part_name: "",
                        num: 1,
                        is_show: 1,
                        is_add: 1,
                        num_edit: 1,
                        goods_list:[]
                    }
                ]
            },
            productFormRules:{
                goods_name:[{ required: true, message: '请填写名称', trigger: 'blue'}],
            },
            regionInfo:null,
            selectedData:[],
            regionAddVisible:false,

        }
    },
    created() {
        if(this.goodsId){
            this.getGoodsDetail()
        }
        if(this.goodsInfo){
            this.productForm = JSON.parse(JSON.stringify(this.goodsInfo))
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        getGoodsDetail(){
            let postData = {
                goods_id : this.goodsId
            }
            this.loading = true
            GoodsBundleProductDetail(postData).then(res => {
                if (res.code === 200) {
                    let { goods_name, image, description,  is_sale, is_lease, part} = res.data
                    part.forEach((item)=>{
                        this.$set(item,'type',item.goods_list ? item.goods_list[0].type : '')
                    })
                    this.productForm = {
                        goods_name,
                        image:image ? image : [],
                        description,
                        is_sale,
                        is_lease,
                        part:part
                    }
                }
                this.loading = false
            })
        },
        // 添加部位
        handleClickAddRegion(){
            let json =  {
                part_name: "",
                num: 1,
                is_show: 1,
                is_add: 1,
                num_edit: 1,
                goods_list:[]
            }
            this.productForm.part.push(json)
        },
        // 切换产品、添加产品
        handleClickChangeProduct(item,type){
            if(type == 'switch'){
                this.regionAddVisible = true
            }else if(type == 'add'){
                this.regionAddVisible = true
            }
            this.regionInfo = item
            this.selectedData = item.goods_list
        },
        // 选择产品后回调
        regionAddSuccess(data){
            if(data[0].type == 'basic'){
                data[0].skus.forEach((list)=>{
                    this.$set(list, 'status', true)
                })
            }
            this.$set(this.regionInfo,'type',data[0].type)
            this.$set(this.regionInfo,'goods_list',data)
        },
        handleClickConfirm(){
            this.$refs.generalForm.validate(valid => {
                if (valid) {

                    if(this.goodsId){
                        let jsonData = {
                            goods_id : this.goodsId,
                            goods_name : this.productForm.goods_name,
                            image: this.productForm.image,
                            description: this.productForm.description,
                            is_sale: this.productForm.is_sale,
                            is_lease: this.productForm.is_lease,
                            unit:'',
                            part: this.productForm.part.map((childMap)=>{
                                return {
                                    goods_part_id: childMap.goods_part_id,
                                    part_name: childMap.part_name,
                                    num: childMap.num,
                                    is_show: childMap.is_show,
                                    is_add: childMap.is_add,
                                    num_edit: childMap.num_edit,
                                    type:childMap.type,
                                    goods_list: childMap.goods_list.map((goodsMap)=>{
                                        return {
                                            goods_id : goodsMap.goods_id,
                                            type : goodsMap.type,
                                            goods_name : goodsMap.goods_name,
                                            brand_name : goodsMap.brand_name,
                                            skus: goodsMap.type == 'basic' ? goodsMap.skus.filter(find => find.status == 1) : goodsMap.skus
                                        }
                                    })
                                }
                            }),
                            is_online:this.productForm.is_sale == 0 && this.productForm.is_lease == 0 ? 0 : 1
                        }
                        if(jsonData.part.filter(item=> item.part_name == '').length){
                            this.$message.error('请填写所有部位名称')
                            return false
                        }
                        if(jsonData.part.filter(item=> item.goods_list.length == 0).length){
                            this.$message.error('请把部位中的产品补充完整')
                            return false
                        }
                        this.BtnDisabled = true
                        GoodsBundleProductEdit(jsonData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    message: '编辑成功',
                                    type: 'success',
                                    duration: 1000,
                                    onClose: () => {
                                        this.BtnDisabled = false
                                        this.$emit('success')
                                        this.handleClickCancel()
                                    }
                                })
                            }else{
                                this.BtnDisabled = false
                            }
                        })
                    }else{
                        if(this.productForm.part.filter(item=> item.part_name == '').length){
                            this.$message.error('请填写所有部位名称')
                            return false
                        }
                        if(this.productForm.part.filter(item=> item.goods_list.length == 0).length){
                            this.$message.error('请把部位中的产品补充完整')
                            return false
                        }
                        this.$emit('success',this.productForm)
                        this.handleClickCancel()
                    }
                }
            })
        },


        //取消事件
        handleClickCancel() {
            //关闭对话框
            this.$emit('update:combinationEditVisible', false)
        },
        // 上传产品图片
        handleClickUploadImg(e,field) {
            const files = Array.from(e.target.files)
            if (field.length === 5) return this.$message.error('最多只能上传5张图片')
            if(files.length + field.length > 5) return this.$message.error('最多只能上传5张图片')
            files.forEach(file => {
                if(file.type != 'image/png' && file.type != 'image/jpeg'){
                    this.$message.error(`${file.name}文件格式不正确`)
                    return false
                }
                uploadImg(file, 2).then(res => {
                    if (res.file_path) {
                        field.push(res.file_path)
                        e.target.value = ''
                    }
                }).catch(error => {
                    e.target.value = ''
                })

            })
        },

    },

}
</script>
<style lang="scss" scoped>
@import "@/styles/product_shelves.scss";
</style>
